"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseAgendaLesson = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var context_1 = require("../context");
var CourseAgendaTopic_1 = __importDefault(require("../CourseAgendaTopic"));
var Header_1 = require("./Header");
var styles_1 = require("./styles");
var course_1 = require("../../../../../utils/course");
var date_fns_1 = require("date-fns");
var CourseAgendaLesson = function (_a) {
    var _b, _c;
    var children = _a.children, _d = _a.defaultOpen, defaultOpen = _d === void 0 ? false : _d, index = _a.index, lesson = _a.lesson, isSubLesson = _a.isSubLesson;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _e = (0, context_1.useCourseAgendaContext)(), areAllTopicsUnlocked = _e.areAllTopicsUnlocked, lockedTopicsIds = _e.lockedTopicsIds, finishedTopicIds = _e.finishedTopicIds, currentLesson = _e.currentLesson, currentLessonParentLessonsIds = _e.currentLessonParentLessonsIds, isMobile = _e.isMobile;
    var _f = (0, react_1.useState)(defaultOpen), open = _f[0], setOpen = _f[1];
    var openMenu = (0, react_1.useCallback)(function () { return setOpen(true); }, []);
    var toggleMenu = (0, react_1.useCallback)(function () { return setOpen(function (prev) { return !prev; }); }, []);
    (0, react_1.useEffect)(function () {
        if (defaultOpen && !open) {
            setOpen(true);
        }
    }, [defaultOpen]);
    var isLessonActive = (0, react_1.useMemo)(function () {
        return !!(lesson.active_from === null ||
            (lesson.active_from &&
                (0, date_fns_1.isAfter)(new Date(), new Date(lesson.active_from))));
    }, [lesson.id]);
    var isModuleFinished = (0, react_1.useMemo)(function () {
        var lessonFlatTopics = (0, course_1.getFlatTopics)([lesson]);
        return (lessonFlatTopics.length > 0 &&
            lessonFlatTopics.every(function (t) { return finishedTopicIds === null || finishedTopicIds === void 0 ? void 0 : finishedTopicIds.includes(t.id); }) &&
            !isSubLesson);
    }, [finishedTopicIds, lesson, isSubLesson]);
    var isRootAncestor = (0, react_1.useMemo)(function () {
        if ((currentLessonParentLessonsIds === null || currentLessonParentLessonsIds === void 0 ? void 0 : currentLessonParentLessonsIds[0]) === undefined)
            return (currentLesson === null || currentLesson === void 0 ? void 0 : currentLesson.id) === lesson.id;
        return currentLessonParentLessonsIds[0] === lesson.id;
    }, [currentLesson === null || currentLesson === void 0 ? void 0 : currentLesson.id, currentLessonParentLessonsIds, lesson.id]);
    var isAncestor = (0, react_1.useMemo)(function () {
        return (currentLessonParentLessonsIds === null || currentLessonParentLessonsIds === void 0 ? void 0 : currentLessonParentLessonsIds.includes(lesson.id)) ||
            (currentLesson === null || currentLesson === void 0 ? void 0 : currentLesson.id) === lesson.id;
    }, [currentLesson === null || currentLesson === void 0 ? void 0 : currentLesson.id, currentLessonParentLessonsIds, lesson.id]);
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledLessonItem, __assign({ className: "lesson__item ".concat(open ? "open" : "closed", " ").concat(isAncestor && !isRootAncestor && open ? "full-border" : "", " ").concat(!isSubLesson ? "bottom-border" : "", " ").concat(isMobile ? "mobile" : ""), "aria-label": "".concat(t("Course.Lesson"), " ").concat(index + 1) }, { children: [(0, jsx_runtime_1.jsx)(Header_1.Header, { lesson: lesson, index: index, open: open, onClick: openMenu, onToggleClick: toggleMenu, isSubLesson: isSubLesson, isModuleFinished: isModuleFinished, isLessonActive: isLessonActive }), (0, jsx_runtime_1.jsx)("ul", __assign({ className: "lesson__topics" }, { children: ((_b = lesson === null || lesson === void 0 ? void 0 : lesson.topics) !== null && _b !== void 0 ? _b : []).map(function (topic, topicIndex) { return ((0, jsx_runtime_1.jsx)(CourseAgendaTopic_1.default, { clickable: areAllTopicsUnlocked ||
                        (!areAllTopicsUnlocked &&
                            open &&
                            !lockedTopicsIds.includes(topic.id)), topic: topic, index: topicIndex + 1 }, topicIndex)); }) })), !!((_c = lesson.lessons) === null || _c === void 0 ? void 0 : _c.length) && ((0, jsx_runtime_1.jsx)("ul", __assign({ className: "lesson__lessons" }, { children: children })))] })));
};
exports.CourseAgendaLesson = CourseAgendaLesson;
exports.default = exports.CourseAgendaLesson;
